var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('height:' + _vm.height + 'px;width:718px')},[_c('canvas',{ref:"canvas",attrs:{"height":_vm.height,"width":"718"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3449a374","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reports/charts/elements/HorizontalBar.vue
// module id = tS+L
// module chunks = 0 1